import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { KYCStatus } from '~/api/KYCStatus';
import navigationHistory from '~/services/NavigationHistory';
import { userStore } from '~/stores';
import { bottomNavigationStore } from '~/stores/BottomNavigationStore';

export const useBottomNavigation = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    bottomNavigationStore.reset();

    if (bottomNavigationStore.filters) {
      bottomNavigationStore.setState('withActions');
      return;
    }
    if (pathname.startsWith('/p/')) {
      bottomNavigationStore.setState('product');
      return;
    }

    if (pathname === '/cart') {
      bottomNavigationStore.setState('cart');
      return;
    }

    if (pathname === '/checkout') {
      bottomNavigationStore.setState('checkout');
      return;
    }

    if (pathname === '/search') {
      bottomNavigationStore.setState('default');
      return;
    }

    const routesWithBack = [
      '/c/',
      '/cabinet/',
      '/orders',
      '/address',
      '/payment',
      '/settings',
      '/notifications',
      '/help',
      '/favs',
    ];

    if (routesWithBack.some((route) => pathname.startsWith(route))) {
      bottomNavigationStore.setState('withBack');
      return;
    }

    // Routes that need back button
    const routesBackOnly = [
      '/about',
      '/terms',
      '/privacy',
      '/contact-us',
      '/legals',
      '/our-story',
      '/order/',
    ];

    if (routesBackOnly.some((route) => pathname.startsWith(route))) {
      bottomNavigationStore.setState('backOnly');
      return;
    }

    // Default state for all other routes
    bottomNavigationStore.setState('default');
  }, [pathname, bottomNavigationStore.filters]);

  return bottomNavigationStore;
};

export const useBottomNavigationBackHandler = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const previousPath = navigationHistory.goBack();

    if (previousPath) {
      if (
        previousPath === '/checkout' &&
        userStore.personalData.kycStatus !== KYCStatus.Verified
      ) {
        navigate('/cabinet');
        return;
      }

      navigate(previousPath);
      return;
    }

    navigate('/');
  }, [navigate]);
};
